import { styled } from "styled-components";

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    min-width: 80px; 
`;
  
export const NotificationContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.2rem;
  padding-bottom: 0.3rem;
`;

export const RiskDot = styled.span`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.tokens.color.icon.error};
  display: inline-block;
  margin-bottom: 0.8rem;
`;